module.exports = __webpack_public_path__ + "img/2.01d9e43e.png";